import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "The Maestro", id: "heritage" },
  { label: "The Cloth", id: "cloth" },
  { label: "Commissions", id: "services" },
  { label: "The Process", id: "process" },
  { label: "Visit", id: "visit" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-[#E5DEC9]/70 bg-[#FFFFFF]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-12 lg:px-20">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-3">
          <img src="/images/logo-mark.png" alt="Bespoke Maestro logo" className="h-11 w-auto" />
          <span className="flex flex-col">
            <span className="font-serif text-xl font-semibold tracking-wide text-[#1A1917]">
              Bespoke Maestro
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#858078]">
              San Diego · Est. 2018
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToSection(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#524F4A] transition-colors duration-200 hover:text-[#1A1917]"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/design"
            data-testid="nav-link-design"
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#8C6D38] transition-colors duration-200 hover:text-[#1A1917]"
          >
            Design Your Own
          </Link>
          <Link
            to="/weddings"
            data-testid="nav-link-weddings"
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#8C6D38] transition-colors duration-200 hover:text-[#1A1917]"
          >
            Weddings
          </Link>
          <Link
            to="/book"
            data-testid="nav-book-appointment-button"
            className="border border-[#1A1917] bg-[#1A1917] px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#FFFFFF] transition-colors duration-200 hover:bg-transparent hover:text-[#1A1917] active:scale-95"
          >
            Book a Fitting
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          className="text-[#1A1917] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E5DEC9] bg-[#FFFFFF] px-6 py-6 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => {
                  setOpen(false);
                  scrollToSection(l.id);
                }}
                className="text-left font-mono text-xs uppercase tracking-[0.25em] text-[#524F4A]"
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/design"
              data-testid="nav-mobile-link-design"
              onClick={() => setOpen(false)}
              className="text-left font-mono text-xs uppercase tracking-[0.25em] text-[#8C6D38]"
            >
              Design Your Own
            </Link>
            <Link
              to="/weddings"
              data-testid="nav-mobile-link-weddings"
              onClick={() => setOpen(false)}
              className="text-left font-mono text-xs uppercase tracking-[0.25em] text-[#8C6D38]"
            >
              Weddings
            </Link>
            <Link
              to="/book"
              data-testid="nav-mobile-book-button"
              className="mt-2 bg-[#1A1917] px-6 py-3 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-[#FFFFFF]"
              onClick={() => setOpen(false)}
            >
              Book a Fitting
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
